module.exports = __webpack_public_path__ + "img/list_3.e76f3fc2.png";